module.exports = __webpack_public_path__ + "img/Picture8.cec1a9a0.png";